<template>
    <a
        class="text-[1rem] leading-[1.8] text-primary-orange lg:text-[1.25rem]"
        :href="href"
        :target="target"
        :rel="rel"
    >
        <slot />
    </a>
</template>

<script setup>
const { href, target, rel } = defineProps({
    href: {
        type: String,
        required: true,
    },
    target: {
        type: String,
        required: false,
    },
    rel: {
        type: String,
        required: false,
    },
});
</script>
